import React from 'react';
import ProductPageTemplate from './ProductPageTemplate';
import {
  ForwardingIcon,
  Tracking,
  Workflow,
  Notifications,
  DocWorkflow,
  Generation,
  Transmission,
  Editor,
} from '../../assets';

const ForwardingPageUAE = () => {
  const productData = {
    productName: 'Forwarding',
    tagline: 'Air & Ocean Freight Management for UAE and Gulf Forwarders',
    metaDescription: 'Freight forwarding software for UAE and Gulf freight forwarders: manage air & ocean FCL/LCL, one-click AWB & BL generation, real-time tracking, and customer collaboration across Jebel Ali, DXB, and global trade lanes.',
    description: 'One platform for your full freight forwarding operation: from inquiry to invoice: covering air freight, ocean FCL and LCL, documentation, real-time tracking, and customer collaboration across the UAE and Gulf region.',
    icon: ForwardingIcon,
    pageUrlOverride: 'https://shipmnts.com/uae/products/forwarding',
    currency: 'USD',
    features: [
      {
        title: 'Multimodal Tracking Automation',
        description: 'Track shipments across air, ocean, and land with automated milestone updates across all major UAE and global ports.',
        image: Tracking,
      },
      {
        title: 'Workflow & Milestone Management',
        description: 'Define custom workflows and track milestones for every shipment: from Jebel Ali to any destination worldwide.',
        image: Workflow,
      },
      {
        title: 'Single-Click Multichannel Notifications',
        description: 'Keep customers informed with automated email, SMS, and WhatsApp updates in real time.',
        image: Notifications,
      },
      {
        title: 'Document-Level Workflow for Forwarding & NVO',
        description: 'Manage complex documentation workflows for both forwarding and NVO operations across UAE and Gulf trade lanes.',
        image: DocWorkflow,
      },
      {
        title: 'Real-Time Document Editor',
        description: 'Edit and finalise shipping documents in real time with built-in validation.',
        image: Editor,
      },
      {
        title: 'Single-Click Multimodal Document Generation',
        description: 'Generate HBL, MBL, AWB, and other documents with one click: automatically populated from shipment records.',
        image: Generation,
      },
      {
        title: 'In-App E-AWB Transmission',
        description: 'Transmit electronic air waybills directly to the airline from within Shipmnts: no third-party tools required.',
        image: Transmission,
      },
    ],
    faqs: [
      {
        question: 'Is Shipmnts suitable for UAE and Gulf freight forwarders?',
        answer: 'Yes. Shipmnts serves freight forwarders across the UAE, Saudi Arabia, Kuwait, Qatar, Bahrain, and Oman. It covers air and ocean forwarding, documentation, real-time tracking, and finance: all in one platform, with support for multi-currency operations.',
      },
      {
        question: 'Which UAE and Gulf ports does Shipmnts support?',
        answer: 'Shipmnts supports all ports globally, including Jebel Ali (JEBEL ALI), Dubai (DXB), Abu Dhabi, Sharjah, Hamad (Qatar), King Abdullah (Saudi Arabia), and all other Gulf and international ports. There is no port-specific restriction.',
      },
      {
        question: 'Does Shipmnts support multi-currency invoicing for UAE operations?',
        answer: 'Yes. Shipmnts supports multi-currency invoicing including AED, USD, EUR, and other major currencies: essential for UAE freight forwarders transacting across multiple trade lanes and currencies.',
      },
      {
        question: 'Can I generate HBL, MBL, and AWB documents from Shipmnts?',
        answer: 'Yes. Shipmnts supports one-click generation of House Bills of Lading (HBL), Master Bills of Lading (MBL), Air Waybills (AWB), delivery orders, and other shipping documents: auto-populated from shipment data.',
      },
      {
        question: 'Does Shipmnts support e-AWB transmission for UAE air freight?',
        answer: 'Yes. Shipmnts enables in-app e-AWB transmission directly to the airline: removing the need for paper AWBs and third-party transmission tools. Supported for air freight from UAE airports including DXB and SHJ.',
      },
    ],
  };

  return <ProductPageTemplate {...productData} />;
};

export default ForwardingPageUAE;
